import { EDITOR_ZOOM_MAX as ZOOM_MAX, EDITOR_ZOOM_MIN as ZOOM_MIN } from '@/lib/zoom/editor-zoom'

/** Persist editor zoom in localStorage (survives refresh). Cleared on logout via `clearAuth`. */
export const EDITOR_ZOOM_STORAGE_KEY = 'editor-zoom.v1'

export function readStoredEditorZoom(): number | null {
  if (typeof window === 'undefined') return null

  try {
    const raw = localStorage.getItem(EDITOR_ZOOM_STORAGE_KEY)

    if (raw == null || raw === '') return null

    const n = JSON.parse(raw) as unknown

    if (typeof n !== 'number' || !Number.isFinite(n)) return null
    if (n === 0) return 0
    if (n < ZOOM_MIN || n > ZOOM_MAX) return null

    return +n.toFixed(3)
  } catch {
    return null
  }
}

export function writeStoredEditorZoom(z: number): void {
  if (typeof window === 'undefined') return

  try {
    if (z === 0) {
      localStorage.setItem(EDITOR_ZOOM_STORAGE_KEY, '0')

      return
    }

    if (!Number.isFinite(z) || z < ZOOM_MIN || z > ZOOM_MAX) return

    localStorage.setItem(EDITOR_ZOOM_STORAGE_KEY, JSON.stringify(+z.toFixed(3)))
  } catch {
    // Quota / private mode — ignore.
  }
}

export function clearStoredEditorZoom(): void {
  if (typeof window === 'undefined') return

  try {
    localStorage.removeItem(EDITOR_ZOOM_STORAGE_KEY)
  } catch {
    // ignore
  }
}
